//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  props: {
    height: {
      type: String,
      default: '252px'
    },
    dateList: {
      type: Array,
      default: []
    },
    top: {
      type: String,
      default: '33px'
    },
    paddingTop: {
      type: String,
      default: '0'
    },
    minSum: {
      type: String,
      default: '0'
    }
  },
  data: function data() {
    return {
      moveState: false,
      overflow: 'hidden',
      dataList: []
    };
  },
  watch: {
    moveState: function moveState(value) {
      if (value) {
        this.overflow = 'auto';
      } else {
        this.overflow = 'hidden';
      }
    },
    dateList: {
      handler: function handler(value) {
        console.log('dateList', value);
        this.dataList = JSON.parse(JSON.stringify(value));
      },
      deep: true,
      immediate: true
    }
  },
  beforeDestroy: function beforeDestroy() {
    clearInterval(this.Inter);
  },
  mounted: function mounted() {
    var _this = this;

    this.Inter = setInterval(function () {
      setTimeout(function () {
        if (_this.dataList.length > _this.minSum) {
          _this.dataList.push(_this.dataList[0]); // 将数组的第一个元素添加到数组的


          _this.dataList.shift(); //删除数组的第一个元素

        }
      }, 500);
    }, 1500);
  },
  methods: {
    toggleState: function toggleState() {
      var _this2 = this;

      this.moveState = !this.moveState;

      if (this.moveState) {
        clearInterval(this.Inter);
      } else {
        var data = JSON.parse(JSON.stringify(this.dataList));
        this.dataList = [];
        setTimeout(function () {
          _this2.dataList = data;
          _this2.Inter = setInterval(function () {
            setTimeout(function () {
              if (_this2.dataList.length > _this2.minSum) {
                _this2.dataList.push(_this2.dataList[0]); // 将数组的第一个元素添加到数组的


                _this2.dataList.shift(); //删除数组的第一个元素

              }
            }, 500);
          }, 1000);
        }, 10);
      }
    }
  }
};